import script from "./stripecancel.vue?vue&type=script&setup=true&lang=js"
export * from "./stripecancel.vue?vue&type=script&setup=true&lang=js"

import "./stripecancel.vue?vue&type=style&index=0&id=a36c7802&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a36c7802"]])

export default __exports__